import { Link } from "react-router-dom";
import { Building2, User, Star } from "lucide-react";
import { formatEuros, formatDate } from "@/lib/format";
import { PastilleEtape } from "@/components/commun";
import { TagPastille } from "@/components/fiche/Tags";

export const FicheCarte = ({ fiche, draggable, onDragStart, extra }) => {
  const Icone = fiche.type_contact === "collectivite" ? Building2 : User;
  const pa = fiche.prochaine_action;
  return (
    <div className="at-fiche relative overflow-hidden transition-transform duration-200 hover:-translate-y-0.5" draggable={draggable} onDragStart={onDragStart} data-testid={`fiche-card-${fiche.id}`}>
      <span className="absolute left-0 top-0 bottom-0 w-1.5" style={{ background: fiche.temperature || "var(--muted)" }} />
      <Link to={`/fiches/${fiche.id}`} className="p-4 pl-5 flex flex-col gap-2.5">
        <div className="flex items-start justify-between gap-3">
          <div className="min-w-0">
            <p className="font-bold truncate flex items-center gap-1.5"><Icone size={15} className="shrink-0 at-muted" />{fiche.nom}{fiche.est_favori && <Star size={13} fill="currentColor" />}</p>
            <p className="text-sm at-muted truncate">{fiche.commune} · {fiche.operation}</p>
          </div>
          <p className="font-bold whitespace-nowrap">{formatEuros(fiche.montant_devis || fiche.montant_estime)}</p>
        </div>
        <div className="flex items-center justify-between gap-2 flex-wrap">
          <span className="flex items-center gap-1.5 min-w-0">
            <PastilleEtape fiche={fiche} testId={`fiche-etape-${fiche.id}`} />
            {fiche.fait_par_ia && <span className="px-2 py-0.5 at-pill text-[11px] font-bold whitespace-nowrap" style={{ background: "color-mix(in srgb, var(--micro) 30%, transparent)" }} data-testid={`fiche-ia-badge-${fiche.id}`}>Fait par l'IA</span>}
          </span>
          <span className="text-xs font-semibold truncate" style={{ color: fiche.sans_action ? "var(--danger)" : "var(--muted)" }} data-testid={`fiche-next-${fiche.id}`}>
            {pa ? `${pa.type_label} · ${formatDate(pa.echeance)}` : fiche.sans_action ? "Sans action" : fiche.statut_label}
          </span>
        </div>
        {fiche.tags?.length > 0 && <div className="flex flex-wrap gap-1">{fiche.tags.map((t) => <TagPastille key={t.id} tag={t} />)}</div>}
      </Link>
      {extra}
    </div>
  );
};
